import React, { useMemo } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import ChoiceList from "./choiceList";
import ColorList from "./colorList";
import FilterPriceRange from "./filterPriceRange";
import ClearFiltersChip from "./clearFiltersChip";
import { useTranslation } from "react-i18next";
import { PRODUCTS_LIST } from "../../../locales/pages/namespaces";
import useUserData from "../../../hooks/user/useUserData";

export default function FiltersSidebar({
  data = {
    categories: [],
    products: [],
    brands: [],
    colors: [],
    price: { min: 0, max: 0 },
  },
  filteredProducts = [],
  filters,
  onToggle,
  onRange,
  showClear = false,
  onReset,
}) {
  const titleSx = {
    fontFamily: "Zen Maru Gothic",
    fontSize: "24px",
    fontWeight: 900,
    mb: 1,
    textTransform: "uppercase",
  };

  const { t } = useTranslation(PRODUCTS_LIST);
  const {isLoggedIn} = useUserData()
  const dynamicPriceRange = useMemo(() => {
    const apiMin = data?.price?.min;
    const apiMax = data?.price?.max;

    if (typeof apiMin === "number" && typeof apiMax === "number") {
      return { min: apiMin, max: apiMax };
    }

    if (!filteredProducts || filteredProducts.length === 0) {
      return { min: 0, max: 0 };
    }

    const prices = filteredProducts
      .map((p) => p.price)
      .filter((p) => typeof p === "number");
    if (prices.length === 0) return { min: 0, max: 0 };

    return {
      min: Math.floor(Math.min(...prices)),
      max: Math.ceil(Math.max(...prices)),
    };
  }, [data?.price, filteredProducts]);


  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: 246,
        borderRadius: 3,
        bgcolor: "#F0F0F0",
        p: 1.5,
        mt: 2,
        display: "flex",
        flexDirection: "column",
        gap: 1.5,
        position: "static",
        height: "auto",
        overflow: "visible",
      }}
    >
      {showClear && (
        <ClearFiltersChip
            label={t("Clear Filters")}
          onClick={onReset}
          sx={{ alignSelf: "flex-start", mb: 1 }}
        />
      )}

      <Box>
        <Typography sx={titleSx}>{t("Categories")}</Typography>
        <ChoiceList
          type="radio"
          items={data.categories ?? []} 
          selected={filters.categories ?? []}
          onChange={(id) => onToggle("categories", id)}
          showMoreCount={9}
          disableZeros={false}
        />
      </Box>
      {/*<Box>*/}
      {/*  <Typography sx={titleSx}>{t("Products")}</Typography>*/}
      {/*  <ChoiceList*/}
      {/*    items={data.products ?? []} */}
      {/*    selected={filters.products ?? []}*/}
      {/*    onChange={(id) => onToggle("products", id)}*/}
      {/*    showMoreCount={9}*/}
      {/*    disableZeros={false}*/}
      {/*  />*/}
      {/*</Box>*/}
      <Box>
        <Typography sx={titleSx}>{t("Brands")}</Typography>
        <ChoiceList
          items={data.brands ?? []}
          selected={filters.brands ?? []}
          onChange={(id) => onToggle("brands", id)}
          showMoreCount={9}
          disableZeros={false}
        />
      </Box>

      <Box>
        <Typography sx={titleSx}>{t("Colors")}</Typography>
        <ColorList
          items={data.colors ?? []}
          selected={filters.colors ?? []}
          onToggle={onToggle}
        />
      </Box>

      {isLoggedIn &&
          <Box>
        <Typography sx={titleSx}>{t("Price")}</Typography>
            <FilterPriceRange
                key={`${dynamicPriceRange.min}-${dynamicPriceRange.max}`}
                min={dynamicPriceRange.min}
                max={dynamicPriceRange.max}
                value={
                  typeof filters.priceMin === "number" &&
                  typeof filters.priceMax === "number"
                      ? [filters.priceMin, filters.priceMax]
                      : [dynamicPriceRange.min, dynamicPriceRange.max]
                }
                onChange={(minPrice, maxPrice) => {
                  onRange(minPrice, maxPrice);
                }}
            />
      </Box>
      }
    </Box>
  );
}
